import { TradingOfferType } from 'types/TradingOffer';

export const addTradingOfferLabels: Record<
  TradingOfferType,
  Record<string, string>
> = {
  [TradingOfferType.SELL]: {
    TITLE: 'ShareSaleOffer',
    DESCRIPTION: 'ShareSaleOfferDescription',
    BREADCRUMB: 'ShareSaleOfferBreadcrumb',
    SELECT_PARTNER: 'SelectPartnerWhoSells',
    SELECT_CLASS: 'SelectClassToSell',
    SHARES_TO_TRANSFER: 'SharesToSell',
    SHARES_TO_TRANSFER_INFO: 'SharesToSellInfo',
    PRICE: 'PriceToSell',
    PRICE_TOTAL: 'PriceToSellTotal',
    PRICE_PER_SHARE_INFO: 'TradingOfferPriceInfo',
    PRICE_TOTAL_INFO: 'TradingOfferTotalPriceInfo',
  },
  [TradingOfferType.BUY]: {
    TITLE: 'ShareBuyOffer',
    DESCRIPTION: 'ShareBuyOfferDescription',
    BREADCRUMB: 'ShareBuyOfferBreadcrumb',
    SELECT_PARTNER: 'SelectPartnerWhoBuys',
    SELECT_CLASS: 'SelectClassToBuy',
    SHARES_TO_TRANSFER: 'SharesToBuy',
    SHARES_TO_TRANSFER_INFO: 'SharesToBuyInfo',
    PRICE: 'PriceToBuy',
    PRICE_TOTAL: 'PriceToBuyTotal',
    PRICE_PER_SHARE_INFO: 'PricePerShareBuy',
    PRICE_TOTAL_INFO: 'PricePerShareBuy',
  },
};
